import React from "react";
import { useModalContext } from "common/contexts";
import { Button } from "components/bootstrap";
import { Markdown } from "components/common";
const EventNotes = ({ editable, securityEvent }) => {
  const { setModal, setEntity } = useModalContext();
  const openMDEditor = () => {
    setEntity(securityEvent);
    setModal("NOTES-EDITOR");
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Markdown, { text: securityEvent.notes || "_No notes_" }), editable && /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", onClick: openMDEditor }, !securityEvent.notes ? "Add" : "Edit"));
};
export default EventNotes;
